import logowhatsapp from '../../../assets/images/logo-whatsapp.png';

const WhatsAppButton = ({ phoneNumber }) => {
  if (!phoneNumber) return null;

  return (
    <a
      href={`https://api.whatsapp.com/send/?phone=${phoneNumber}`}
      rel='noopener noreferrer'
      target='_blank'
      aria-label='Contactar por WhatsApp'
      className='fixed bottom-4 right-4 z-[99999999] transition-transform duration-200 ease-in-out hover:scale-110'
    >
      <img alt='Icono de WhatsApp' src={logowhatsapp} className='h-12 w-12 cursor-pointer' />
    </a>
  );
};

export default WhatsAppButton;
